import { BridgingProductFeeTypeModal } from '@shared/models';
import { CustomFeeDisplayModel } from '@shared/models/custom-product-calculations';

export enum ProductFeeType {
  Valuation = 0,
  Booking = 1,
  Broker = 2,
  Arrangement = 3,
  Chaps = 4,
  Conveyancing = 6,
  DeedsRelease = 7,
  MortgageExit = 11,
  Packager = 15,
  Custom = 16,
  FurtherAdvance = 17,
  AssumedLegal = 18,
  EarlyRepayment = 19,
}

interface FeeTypesObj {
  name: string;
  key: ProductFeeType;
}

export const feesDisplayNames: Record<ProductFeeType, string> = {
  [ProductFeeType.Arrangement]: 'Arrangement fee',
  [ProductFeeType.Booking]: 'Booking fee',
  [ProductFeeType.Broker]: 'Broker fee',
  [ProductFeeType.Chaps]: 'Chaps fee',
  [ProductFeeType.Conveyancing]: 'Conveyancing fee',
  [ProductFeeType.DeedsRelease]: 'Deeds release fee',
  [ProductFeeType.MortgageExit]: 'Mortgage exit fee',
  [ProductFeeType.Packager]: 'Packager fee',
  [ProductFeeType.Valuation]: 'Valuation fee',
  [ProductFeeType.FurtherAdvance]: 'Further advance fee',
  [ProductFeeType.AssumedLegal]: 'Assumed legal fee',
  [ProductFeeType.Custom]: 'Custom fee',
  [ProductFeeType.EarlyRepayment]: 'Early repayment charges',
};

const bridgingFeesDisplayNames: Record<BridgingProductFeeTypeModal, string> = {
  [BridgingProductFeeTypeModal.Admin]: 'Administration fee',
  [BridgingProductFeeTypeModal.Arrangement]: 'Arrangement fee',
  [BridgingProductFeeTypeModal.Avm]: 'AVM fee',
  [BridgingProductFeeTypeModal.Chaps]: 'Chaps fee',
  [BridgingProductFeeTypeModal.Legal]: 'Legal fee',
  [BridgingProductFeeTypeModal.Valuation]: 'Valuation fee',
};

export const feeDisplayModel: CustomFeeDisplayModel[] = [
  { type: ProductFeeType.Arrangement, customName:'', displayName: 'Arrangement fee', isCustom: false },
  { type: ProductFeeType.Booking, customName:'', displayName: 'Booking fee', isCustom: false },
  { type: ProductFeeType.Broker, customName:'', displayName: 'Broker fee', isCustom: false },
  { type: ProductFeeType.Chaps, customName:'', displayName: 'Chaps fee', isCustom: false },
  { type: ProductFeeType.Conveyancing, customName:'', displayName: 'Conveyancing fee', isCustom: false },
  { type: ProductFeeType.DeedsRelease, customName:'', displayName: 'Deeds release fee', isCustom: false },
  { type: ProductFeeType.MortgageExit, customName:'', displayName: 'Mortgage exit fee', isCustom: false },
  { type: ProductFeeType.Packager, customName:'', displayName: 'Packager fee', isCustom: false },
  { type: ProductFeeType.FurtherAdvance, customName:'', displayName: 'Further advance fee', isCustom: false },
  { type: ProductFeeType.Valuation, customName:'', displayName: 'Valuation fee', isCustom: false },
  { type: ProductFeeType.Custom, customName:'', displayName: 'Custom fee', isCustom: true },
  { type: ProductFeeType.AssumedLegal, customName:'', displayName: 'Assumed legal fee', isCustom: true },
  { type: ProductFeeType.EarlyRepayment, customName:'', displayName: 'Early repayment charges', isCustom: false },
];

export function getFormattedFeeTypes(skipEntry?: ProductFeeType[]): FeeTypesObj[] {
  return feeDisplayModel.filter(fee =>!skipEntry?.includes(fee.type)).map(fee => {
    return {
      name: fee.displayName,
      key: fee.type,
    } as FeeTypesObj;
  });
}

export function getFeeDisplayNameNumeric(fee: ProductFeeType): string {
  return feesDisplayNames[fee] ?? '';
}

export function getBridgingFeeDisplayName(fee: BridgingProductFeeTypeModal | string): string {
  return bridgingFeesDisplayNames[fee as BridgingProductFeeTypeModal] ?? fee;
}

export enum FeeCalculationScenario {
  Exclude = 0,
  AddToLoan = 1,
  OneOffCost = 2,
}
export const disabledFees: Map<FeeCalculationScenario, ProductFeeType[]> = new Map([
  [FeeCalculationScenario.Exclude, [ProductFeeType.Arrangement, ProductFeeType.Chaps]],
  [FeeCalculationScenario.AddToLoan, [ProductFeeType.Broker, ProductFeeType.AssumedLegal, ProductFeeType.EarlyRepayment]],
]);
